import {
  approvalNotiTypes,
  serviceNotiTypes,
  supervisorNotiTypes,
  fleetNotiTypes,
  fleetAdminOnlyNotiTypes
} from "../Domain/NotificationSettings.data";
import { NotificationDataType } from "../Domain/NotificationSettings.types";

export function shouldIncludeNotificationOption(
  opt: { name: string },
  states: {
    isTenantAdmin: boolean;
    isCompanyAdmin: boolean;
    isRequestAdmin: boolean;
    isFleetAdmin: boolean;
    teamBookingAllowed: boolean;
    activateBookingServices: boolean;
    fleetEnabledForTenant: boolean;
  }
): boolean {
  const {
    isTenantAdmin,
    isCompanyAdmin,
    isRequestAdmin,
    isFleetAdmin,
    teamBookingAllowed,
    activateBookingServices,
    fleetEnabledForTenant
  } = states;

  // Only include Supervisor notifications if isTenantAdmin or isCompanyAdmin is true
  /* istanbul ignore next */
  if (supervisorNotiTypes.includes(opt.name as NotificationDataType)) {
    return isTenantAdmin || isCompanyAdmin;
  }

  // Approval admin notification
  // if (opt.name === NotificationDataType.BOOKING_APPROVAL_ADMIN) return isRequestAdmin; }
  if (approvalNotiTypes.includes(opt.name as NotificationDataType)) return isRequestAdmin;

  // Team booking notification
  if (opt.name === NotificationDataType.TEAM_BOOKING) {
    return teamBookingAllowed;
  }

  // Service booking uses
  if (serviceNotiTypes.includes(opt.name as NotificationDataType)) return activateBookingServices;

  // Fleet notifications: only when fleet is enabled for the tenant
  if (fleetAdminOnlyNotiTypes.includes(opt.name as NotificationDataType)) {
    return fleetEnabledForTenant && isFleetAdmin;
  }

  if (fleetNotiTypes.includes(opt.name as NotificationDataType)) {
    return fleetEnabledForTenant;
  }

  // All other options are included
  return true;
}
